// Desktop tools fill what is left of the window under the header so the page itself never scrolls.
// Sets the height on `element` as a CSS variable and returns it, or null when the element is not
// on screen yet (its top is 0 while its tab is hidden).
export const fitHeightBelowHeader = (element, cssVariable) => {
  window.scrollTo(0, 0)
  const top = element.getBoundingClientRect().top + window.scrollY
  if (top <= 0) return null

  const available = window.innerHeight - top
  element.style.setProperty(cssVariable, `${available}px`)
  return available
}
